function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M5.25 17.0625C5.25 18.1493 6.13134 19.0312 7.21875 19.0312H13.7812C14.868 19.0312 15.75 18.1493 15.75 17.0625L17.0625 6.5625H3.9375L5.25 17.0625ZM12.4688 8.53125H13.7812V17.0625H12.4688V8.53125ZM9.84375 8.53125H11.1562V17.0625H9.84375V8.53125ZM7.21875 8.53125H8.53125V17.0625H7.21875V8.53125ZM16.7344 3.9375H12.4688C12.4688 3.9375 12.1748 2.625 11.8125 2.625H9.1875C8.82459 2.625 8.53125 3.9375 8.53125 3.9375H4.26562C3.72159 3.9375 3.28125 4.37784 3.28125 4.92188C3.28125 5.46591 3.28125 5.90625 3.28125 5.90625H17.7188C17.7188 5.90625 17.7188 5.46591 17.7188 4.92188C17.7188 4.37784 17.2778 3.9375 16.7344 3.9375Z",
  fill: "black"
});

function SvgDelete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.95673d5bda8f3ead6db73198b70fccab.svg";
export { ForwardRef as ReactComponent };